export enum HotelBookingType {
  Business = 0,
  Personal = 1,
  Group = 2
}
